module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAAMFBMVEUAAABEif9Jh/9EiP9Gh/9Eh/9Fh/9FiP9EiP9FiP9Gif9Gh/9FiP9HiP9Fiv9Eh//YZ0LBAAAAD3RSTlMAfzG0ZuzMntaUInVvXj+/zOo3AAAARklEQVQ4y2MgG2wNDQ29gEVc/v///w6j4vQW5zSGgn6geDOUbcPAwPYfC/g++MS5lKBgPpAvBGVrDb5wHrHiDwUFBRXgPAANxg7YfztRaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gem/plus_sign.png
// module id = MNO1
// module chunks = 1